export const base = {
  api: process.env.REACT_APP_API,
  apiTakt: process.env.REACT_APP_API_TAKT,
  apiAnalytics: process.env.REACT_APP_API_ANALYTICS,
  base: process.env.REACT_APP_BASE,
  front: process.env.REACT_APP_FRONT,
  socketApi: process.env.REACT_APP_SOCKET_API,
  apiJava: process.env.REACT_APP_API_JAVA,
  procoreEnv: process.env.REACT_APP_PROCORE_ENV,
  procoreLogin: process.env.REACT_APP_PROCORE_LOGIN,
  procoreUrl: process.env.REACT_APP_PROCORE_URL,
  procoreClientId: process.env.REACT_APP_PROCORE_CLIENT_ID,
  backendExportable: process.env.REACT_APP_BACKEND_EXPORTABLE,
  exportableUrl: process.env.REACT_APP_EXPORTABLE_NODE,
  uiAnalytics: process.env.REACT_APP_UI_ANALYTICS,
  returnEnviroment: process.env.REACT_APP_ENV || "local",
  masterKey: process.env.REACT_APP_MASTER_KEY,
  version: process.env.REACT_APP_VERSION,
  autodesk: {
    showIntegration: true,
    client: process.env.REACT_APP_AUTODESK_CLIENT,
    secret: process.env.REACT_APP_AUTODESK_SECRET,
    authWithCodeUrl: process.env.REACT_APP_AUTODESK_AUTH_URL,
    redirectUri: `${window.location.origin}/settings/plugins`
  }
};
